import { createSlice } from "@reduxjs/toolkit";
import { getIsoEnrollmentList, updateIso } from "./IsoEnrollment.thunk";

const baseState = {
  isoEnrollmentData: [],
  isoEnrollmentSelected: null,
  isoEnrollmentDataById: null,
  page: 1,
  pageSize: 5,
  totalRecords: 0,
  status: "idle",
  statusUpdate: "idle",
  error: null,
};

const initialState = {
  ...baseState,
};

const calculatePaginatedData = (data, page, pageSize) => {
  const startIndex = (page - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  return data.slice(startIndex, endIndex);
};

export const isoEnrollmentSlice = createSlice({
  name: "isoEnrollment",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
      state.isoEnrollmentDataPaginated = calculatePaginatedData(
        state.isoEnrollmentData, 
        state.page, 
        state.pageSize
      );
    },
    
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
      state.isoEnrollmentDataPaginated = calculatePaginatedData(
        state.isoEnrollmentData, 
        state.page, 
        state.pageSize
      );
    },
    
    resetPagination: (state) => {
      state.page = 1;
      state.totalRecords = 0;
      state.isoEnrollmentDataPaginated = calculatePaginatedData(
        state.isoEnrollmentData, 
        state.page, 
        state.pageSize
      );
    },
    
    ResetStore: (state) => {
      state = { ...baseState };
    },

    setIsoEnrollmentSelected: (state, action) => {
      state.isoEnrollmentSelected = action.payload;
    },

    setIsoEnrollmentDataById: (state, action) => {
      state.isoEnrollmentDataById = action.payload;
    },
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIsoEnrollmentList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getIsoEnrollmentList.fulfilled, (state, action) => {
        const { data, page, page_size, total_pages, total_records } =
          action.payload;
        state.status = "succeeded";
        state.isoEnrollmentData = data;
        state.page = page;
        state.pageSize = page_size;
        state.totalPages = total_pages;
        state.totalRecords = total_records;
      })
      .addCase(getIsoEnrollmentList.rejected, (state, action) => {
        state.status = "failed";
        state.isoEnrollmentData = [];
        state.page = 1;
        state.pageSize = 5;
        state.totalPages = 0;
        state.totalRecords = 0;
        state.error = action?.payload?.message || "Error fetching iso enrollment list";
      })
      // Update ISO
      .addCase(updateIso.pending, (state) => {
        state.statusUpdate = "loading";
      })
      .addCase(updateIso.fulfilled, (state, action) => {
        state.statusUpdate = "succeeded";
        state.isoEnrollmentSelected = null;
        state.isoEnrollmentDataById = null;
      })
      .addCase(updateIso.rejected, (state, action) => {
        state.statusUpdate = "failed";
        state.error = action?.payload?.message || "Error updating ISO";
      });
  },
});

export const { 
  ResetStore,
  setPage,
  setPageSize,
  resetPagination,
  setIsoEnrollmentSelected,
  setIsoEnrollmentDataById
} = isoEnrollmentSlice.actions;

export default isoEnrollmentSlice.reducer;
